/* eslint-disable */
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { TextBox } from "./text-box";
import { FieldPreviewComponent } from "../../field-preview.component";

@Component({
    selector: "text-box",
    templateUrl: "./text-box.component.html",
    styles: [
        `
            .field-placeholder {
                background: #ccc;
                border: dotted 3px #999;
                min-height: 60px;
                transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
            }

            fieldset {
                height: 300px;
            }

            mat-list-item {
                display: block !important;
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextBoxComponent extends FieldPreviewComponent implements OnInit, OnDestroy {
    constructor(private _changeDetector: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        this.field.onChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe((changed) => {
            this._changeDetector.detectChanges();
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get textBox() {
        return this.field as TextBox;
    }
}
